var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.058 2.144c.53-.7 1.55-.853 2.275-.34.726.513.884 1.497.353 2.197l-5.38 7.1a1 1 0 01-1.493.114l-4.337-4.2a1.535 1.535 0 01.002-2.223 1.67 1.67 0 012.303.002l2.462 2.384 3.815-5.034z",
    fill: "current"
  })));
}
export default SvgCheck;